(function ($) {
    $(function () {
        $(".ppc-content input[type='text'], .ppc-content input[type='email'], .ppc-content input[type='tel']").each(function () {
            input = $(this);
            label = input.prev("label");
            required = $(this).parent(".required-field");

            if (input.length > 0) {
                if (required.length > 0) {
                    input.attr("placeholder", "* " + label.text());
                } else {
                    input.attr("placeholder", label.text());
                }
            }

        });
    });
})($JQ);